import React from "react";
import { useLocation, Link } from "react-router-dom";
import { getImg, appVersion } from "./utils";
import { logo, landing, apple_store, play_store } from "./pngs";
import { GenericPage, ErrorPage } from "./components";

export const LandingPage = () => {
  const title = "Gracias por preferir a nuestras marcas aliadas";
  const subtitle =
    "Descarga Spin Premia para ganar puntos y disfrutar de todos tus beneficios";
  let destiny = process.env.REACT_APP_DESTINY;
  const apple = process.env.REACT_APP_STORE_IOS;
  const play = process.env.REACT_APP_STORE_ANDROID;
  const location = useLocation();
  const qp = new URLSearchParams(location.search);
  if (
    // key and partner_id
    (qp.get("key") && qp.get("partner_id")) ||
    // only key
    (qp.get("key") && !qp.get("partner_id"))
  ) {
    destiny += location.search;
    window.location.replace(destiny);
  }

  return (
    <>
      <div className="version-tag">{appVersion()}</div>
      <GenericPage
        logo={logo}
        image={landing}
        title={title}
        subtitle={subtitle}
      >
        <div className="app-stores-buttons">
          {!apple ? null : (
            <div className="app-store">
              <Link to={apple}>{getImg(apple_store)}</Link>
            </div>
          )}
          {!play ? null : (
            <div className="app-store">
              <Link to={play}>{getImg(play_store)}</Link>
            </div>
          )}
        </div>
      </GenericPage>
    </>
  );
};

export const NotFoundPage = () => {
  const title = "Error 404";
  const subtitle =
    "No encontramos la página que buscas, por favor regresa al Inicio";
  return <ErrorPage title={title} subtitle={subtitle} />;
};
